import React from 'react'
import type { HTMLAttributes, ReactNode } from 'react'
import { useDrawer } from '@/ui/components'

import { ProductDetailsDrawer } from '.'
import type { ProductDetailsDrawer_Product$key } from './__generated__/ProductDetailsDrawer_Product.graphql'

type ProductDetailsSectionProps = {
  children: ReactNode
  productDescription: ProductDetailsDrawer_Product$key | null
} & HTMLAttributes<HTMLDivElement>

export const ProductDetailsSection = ({
  children,
  productDescription,
  ...props
}: ProductDetailsSectionProps) => {
  const productDetailsDrawer = useDrawer({
    route: '#/product-details-drawer',
  })

  return (
    <div data-testid="product-details-section" {...props}>
      {children}
      <ProductDetailsDrawer
        productDescription={productDescription}
        isOpen={productDetailsDrawer.isOpen}
        onClose={() => productDetailsDrawer.onClose()}
      />
    </div>
  )
}
